import {forwardRef, ForwardedRef} from "react";
import FaiBoxRoot from "./FaiBoxRoot";

interface FaiBoxProps {
    variant?: "contained" | "gradient";
    bgColor?: string;
    color?: string;
    opacity?: number;
    borderRadius?: string;
    shadow?: string;

    [key: string]: any;
}

const FaiBox = forwardRef((props: FaiBoxProps, ref: ForwardedRef<any>) => {
    const {
        variant = "contained",
        bgColor = "transparent",
        color = "dark",
        opacity = 1,
        borderRadius = "none",
        shadow = "none",
        ...rest
    } = props;

    return (
        <FaiBoxRoot
            {...rest}
            ref={ref}
            ownerState={{variant, bgColor, color, opacity, borderRadius, shadow}}
        />
    );
});

export default FaiBox;
